import { Link } from "react-router-dom";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";

import "./LessonDropdown.css";

const menuItems = [
  { label: "Клас 1", to: "/class/1", icon: <SchoolRoundedIcon /> },
  { label: "Клас 2", to: "/class/2", icon: <SchoolRoundedIcon /> },
  { label: "Клас 3", to: "/class/3", icon: <SchoolRoundedIcon /> },
  { label: "Клас 4", to: "/class/4", icon: <SchoolRoundedIcon /> },
  { label: "Клас 5", to: "/class/5", icon: <SchoolRoundedIcon /> },
  { label: "Клас 8", to: "/class/8", icon: <SchoolRoundedIcon /> },
  { label: "Клас 9", to: "/class/9", icon: <SchoolRoundedIcon /> },
  { label: "Клас 10", to: "/class/10", icon: <SchoolRoundedIcon /> },
  { label: "Інструкція", to: "/instruction", icon: <InfoOutlinedIcon /> },
  { label: "Про додаток", to: "/about", icon: <InfoOutlinedIcon /> },
  { label: "Про підручники", to: "/author_info", icon: <MenuBookRoundedIcon /> },
];

function LessonDropdown({ onNavigate }) {
  return (
    <List className="mobile-menu-list" disablePadding>
      <Typography className="mobile-menu-list__label" variant="overline">
        Навігація
      </Typography>
      {menuItems.map((item) => (
        <ListItemButton
          key={item.to}
          component={Link}
          to={item.to}
          onClick={onNavigate}
          className="mobile-menu-list__item"
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItemButton>
      ))}
    </List>
  );
}

export default LessonDropdown;
